<div class="container-fluid main-content g-0">
    <div *ngIf="!isMobile" class="block-finder row no-gutters d-flex">
        <div  class="decor block-finder__decor decor--type--bottom">
            <div class="decor__body">
                <div class="decor__start"></div>
                <div class="decor__end"></div>
                <div class="decor__center"></div>
            </div>
        </div>
        <div id="boxCarousel" class="col-xl-12 col-12 p-0 order-0 order-lg-1">
            <app-home-carousel></app-home-carousel>
        </div>
    </div>

    <div *ngIf="!isMobile" class="block-space block-space--layout--divider-xl"></div>

    <section id="servizi" class="container text-center" [ngClass]="{'section-mobile': isMobile}">
        <h3>NOS PRODUITS</h3>
         <div class="row">
            <div class="item col-12 col-md-6 p-2 text-center">
                <a routerLink="/fr/search-products/Q175-3020/Evok_performance">
                    <img src="https://static.rms.it/evok/servizi1.jpg" class="img-fluid" alt="Evok performance" />
                    <h5>EVOK PERFORMANCE</h5>
                    <p class="text-big">
                        Les pièces détachées Evok PERFORMANCE garantissent une démarche d'amélioration technique et esthétique par rapport à la pièce détachée d'origine.
                    </p>
                </a>
            </div>
            <div class="item col-12 col-md-6 p-2 text-center">
                <a routerLink="/fr/search-products/Q175-5146/Evok_Oem_Series">
                    <img src="https://static.rms.it/evok/servizi2.jpg" class="img-fluid"  alt="Evok Oem" />
                    <h5>EVOK OEM SERIES</h5>
                    <p class="text-big">
                        Les produits Evok OEM SERIES bénéficient d'une qualité égale ou supérieure à la pièce détachée d'origine, en conservant les caractéristiques techniques inchangées.
                    </p>
                </a>
            </div>
        </div>
    </section>

    <section id="prod-ricercati" class="container-fluid text-center bg-light pb-5">
        <h4>NOUVELLES PRODUITS</h4>
        <div  *ngIf="!isMobile" class="block-space block-space--layout--divider-nl"></div>
        <div class=" container">
          <app-product-slider></app-product-slider>
        </div>
    </section>

    <div class="block-space block-space--layout--divider-xl"></div>
    <div class="block block-posts-carousel block-posts-carousel--layout--grid" data-layout="grid">
        <app-home-news></app-home-news>
    </div>
    
    <div class="block-space block-space--layout--divider-xl"></div>    
    <section id="cerca-rivenditore" class="container-fluid d-flex align-items-center justify-content-center flex-column" type="button" routerLink="/it/store-locator">
        <div class="container text-center bg-glass-dark p-5 mb-3">
            <h3 *ngIf="!isMobile">DEALER LOCATOR</h3>
            <h3 *ngIf="isMobile" style="font-size: 38px;">DEALER LOCATOR</h3>
            <p class="text-big">
                Trouvez votre revendeur officiel Evok le plus proche où vous pourrez acheter les pièces détachées adaptées à votre véhicule !
            </p>
        </div>
    </section>
</div>